module.exports = __webpack_public_path__ + "img/mg5.25596d07.jpg";